import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@clerk/tanstack-react-start';
import * as React from 'react';
import { useQuery } from 'convex/react';
import { api } from '@/convex';
import { buildDashboardPath, ROUTES } from '@/lib/routes';

export const Route = createFileRoute('/')({
  component: RootRedirect,
});

function RootRedirect() {
  const { isLoaded, isSignedIn, userId } = useAuth();
  const navigate = useNavigate();

  const memberships = useQuery(
    api.memberships.listByUser,
    isSignedIn && userId ? { clerkUserId: userId } : 'skip',
  );

  React.useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) {
      navigate({ to: ROUTES.SIGN_IN, replace: true });
      return;
    }
    if (memberships === undefined) return;

    if (memberships.length > 0) {
      const orgSlug = (memberships[0].org as { slug?: string })?.slug;
      if (orgSlug) {
        navigate({ to: buildDashboardPath(orgSlug) as any, replace: true });
        return;
      }
    }
    navigate({
      to: ROUTES.ONBOARDING,
      search: { checkout: undefined },
      replace: true,
    });
  }, [isLoaded, isSignedIn, navigate, memberships, userId]);

  return null;
}
